export default {
  debug: true,
  cwUrl: process.env.REACT_APP_LEGACY_EN,
  baseUrl: {
    en: process.env.REACT_APP_BASEURL_EN,
    cy: process.env.REACT_APP_BASEURL_CY
  },
  basePath: {
    en: process.env.REACT_APP_BASEPATH_EN,
    cy: process.env.REACT_APP_BASEPATH_CY
  },
  domain:  process.env.REACT_APP_DOMAIN,
  themePath:  process.env.REACT_APP_DOMAIN_THEME_PATH,
  endpoints: {
    settings: {
      en: process.env.REACT_APP_SETTINGS_EN,
      cy: process.env.REACT_APP_SETTINGS_CY
    },
    statistics: {
      summary:process.env.REACT_APP_COURSES_PORTAL_STATISTICS_SUMMARY,
      review:process.env.REACT_APP_COURSES_PORTAL_STATISTICS_REVIEW,
      q:process.env.REACT_APP_COURSES_PORTAL_STATISTICS_Q
    },
    courses:{
      assets:process.env.REACT_APP_COURSES_PORTAL_COURSES_ASSETS,
      q: process.env.REACT_APP_COURSES_PORTAL_COURSES_Q,
      create:process.env.REACT_APP_COURSES_PORTAL_COURSES_CREATE,
      ids: process.env.REACT_APP_COURSES_PORTAL_COURSES_IDS,
      list:process.env.REACT_APP_COURSES_PORTAL_COURSES_LIST,
      group:process.env.REACT_APP_COURSES_PORTAL_COURSES_GROUP,
      delete: process.env.REACT_APP_COURSES_PORTAL_COURSES_DELETE,
      deleteDraft: process.env.REACT_APP_COURSES_PORTAL_COURSES_DELETE_DRAFT,
      archive: process.env.REACT_APP_COURSES_PORTAL_COURSES_ARCHIVE,
    },
    venues: {
      assets: process.env.REACT_APP_COURSES_PORTAL_VENUES_ASSETS,
      compare: process.env.REACT_APP_COURSES_PORTAL_VENUES_COMPARE,
      assign: process.env.REACT_APP_COURSES_PORTAL_VENUES_ASSIGN,
      ids: process.env.REACT_APP_COURSES_PORTAL_VENUES_IDS,
      q: process.env.REACT_APP_COURSES_PORTAL_VENUES_Q,
      mq: process.env.REACT_APP_COURSES_PORTAL_VENUES_MQ,
      create: process.env.REACT_APP_COURSES_PORTAL_VENUES_CREATE,
      edit: process.env.REACT_APP_COURSES_PORTAL_VENUES_EDIT,
      delete: process.env.REACT_APP_COURSES_PORTAL_VENUES_DELETE,
      deleteDraft: process.env.REACT_APP_COURSES_PORTAL_VENUES_DELETE_DRAFT,
      archive: process.env.REACT_APP_COURSES_PORTAL_VENUES_ARCHIVE,
      duplicate: process.env.REACT_APP_COURSES_PORTAL_VENUES_DUPLICATE,
      addressFinder: process.env.REACT_APP_COURSES_PORTAL_VENUES_ADDRESS_FINDER
    },
    contacts: {
      assets: process.env.REACT_APP_COURSES_PORTAL_CONTACTS_ASSETS,
      ids: process.env.REACT_APP_COURSES_PORTAL_CONTACTS_IDS,
      mq: process.env.REACT_APP_COURSES_PORTAL_CONTACTS_MQ,
      q: process.env.REACT_APP_COURSES_PORTAL_CONTACTS_Q,
      delete: process.env.REACT_APP_COURSES_PORTAL_CONTACTS_DELETE,
      create: process.env.REACT_APP_COURSES_PORTAL_CONTACTS_CREATE,
      deleteDraft: process.env.REACT_APP_COURSES_PORTAL_CONTACTS_DELETE_DRAFT,
      archive:process.env.REACT_APP_COURSES_PORTAL_CONTACTS_ARCHIVE
    },
    courseGroups: {
      ids: process.env.REACT_APP_COURSES_PORTAL_COURSE_GROUPS,
      q: process.env.REACT_APP_COURSES_PORTAL_COURSE_GROUPS_Q,
      mq: process.env.REACT_APP_COURSES_PORTAL_COURSE_GROUPS_MQ,
      create: process.env.REACT_APP_COURSES_PORTAL_COURSE_GROUPS,
      assets: process.env.REACT_APP_COURSES_PORTAL_COURSE_GROUPS_ASSETS
    },
    qualifications: {
      assets: process.env.REACT_APP_COURSES_PORTAL_QUALIFICATIONS_ASSETS,
      ids: process.env.REACT_APP_COURSES_PORTAL_QUALIFICATIONS_IDS,
      mq: process.env.REACT_APP_COURSES_PORTAL_QUALIFICATIONS_MQ
    },
    classifications: {
      ids: process.env.REACT_APP_COURSES_PORTAL_CLASSIFICATIONS_IDS,
      mq: process.env.REACT_APP_COURSES_PORTAL_CLASSIFICATIONS_MQ
    },
    profile: {
      account: process.env.REACT_APP_COURSES_PORTAL_PROFILE_ACCOUNT
    },
    provider:  process.env.REACT_APP_COURSES_PORTAL_PROVIDER,
    translators: process.env.REACT_APP_COURSES_PORTAL_TRANSLATORS,
    dynamics:process.env.REACT_APP_COURSES_PORTAL_DYNAMICS
  },
  styleguide: process.env.REACT_APP_STYLEGUIDE,
  googleTagManager: {
    analytics: process.env.REACT_APP_GTM_ANALYTICS,
    marketing: process.env.REACT_APP_GTM_MARKETING,
    personalisation: process.env.REACT_APP_GTM_PERSONALISATION,
    webchat: process.env.REACT_APP_GTM_WEBCHAT
  },
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  auth: {
    disableSessionExtension: true,
    debug: false,
    autoLogin: false,
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: {
      en: process.env.REACT_APP_BASEURL_EN + process.env.REACT_APP_BASEPATH_EN,
      cy: process.env.REACT_APP_BASEURL_CY + process.env.REACT_APP_BASEPATH_CY
    },
    profile: {
      en: process.env.REACT_APP_PROFILE_BASEPATH_EN,
      cy: process.env.REACT_APP_PROFILE_BASEPATH_CY
    }
  },
  cw: {
    en: process.env.REACT_APP_CW_EN,
    cy: process.env.REACT_APP_CW_CY
  },
  ww: {
    en: process.env.REACT_APP_WW_EN,
    cy: process.env.REACT_APP_WW_CY
  },
  feedbackPrompt: false
};
